export default {
  ['logout'](state, payload) {
    Object.assign(state, payload)
  },
  ['setLoading'](state, status) {
    state.loading = status;
  },
  ['setProjectTypes'](state, types) {
    state.projectTypes = types;
  },
  ['setBrandDetectionModels'](state, models_types) {
    state.brandDetectionModels = models_types;
  }
}
